import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-lg-1 col-mb-2 col-sm-2 col-12 " }, null, -1)
const _hoisted_4 = { class: "col-lg-10 col-md-9 col-sm-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h4 text-left mb-3 mt-3" }, "Identification")
], -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-1" }
const _hoisted_8 = {
  key: 0,
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
}, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "text-success"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
  })
], -1)
const _hoisted_12 = { class: "col-7 text-left" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h6", { class: "font-weight-bold" }, [
  /*#__PURE__*/_createTextVNode(" Photo of your Government Issued ID "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("small", null, " A clear photo of your government issued driver’s license (front and back), passport, or a permanent resident card. ", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "col d-flex justify-content-end align-items-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "row mt-3" }
const _hoisted_21 = { class: "col-1" }
const _hoisted_22 = {
  key: 0,
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
}, null, -1)
const _hoisted_24 = {
  key: 1,
  class: "text-success"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
  })
], -1)
const _hoisted_26 = { class: "col-7 text-left" }
const _hoisted_27 = /*#__PURE__*/_createVNode("h6", { class: "font-weight-bold" }, " Photo of your Government Issued ID (Back) ", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("small", null, " Back of Driver’s License: (required if using license, optional if using passport) ", -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "col d-flex justify-content-end align-items-center" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h4 text-left mt-3 mb-3" }, " Verification Document ")
], -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-1" }
const _hoisted_38 = {
  key: 0,
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
}, null, -1)
const _hoisted_40 = {
  key: 1,
  class: "text-success"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
  })
], -1)
const _hoisted_42 = { class: "col-7 text-left" }
const _hoisted_43 = /*#__PURE__*/_createVNode("h6", { class: "font-weight-bold" }, [
  /*#__PURE__*/_createTextVNode(" Proof of Address "),
  /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("small", null, " Internet Bill, Phone Bill, Hydro Bill. ", -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "col d-flex justify-content-end align-items-center" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 0,
  class: "row mt-5"
}
const _hoisted_51 = { class: "col" }
const _hoisted_52 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sat-street"
}, [
  /*#__PURE__*/_createVNode("svg", {
    style: {"width":"1rem","height":"1rem"},
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      fill: "currentColor",
      d: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Previous ")
], -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Complete ")
const _hoisted_54 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "col-lg-3 col-mb-2 col-sm-1 col-12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            (!_ctx.identificationSuccess)
              ? (_openBlock(), _createBlock("svg", _hoisted_8, [
                  _hoisted_9
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_10, [
                  _hoisted_11
                ]))
          ]),
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            (_ctx.identificationSuccess)
              ? (_openBlock(), _createBlock("small", _hoisted_15, [
                  _createVNode("a", {
                    class: "link pointer",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadDocument(_ctx.identificationKey)))
                  }, " See Uploaded Document. ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("input", {
              onInput: _cache[2] || (_cache[2] = e => _ctx.onOpenFile(e, 'identification')),
              style: {"display":"none"},
              id: "file-identification",
              type: "file",
              accept: "image/*, application/pdf",
              class: "btn btn-sat-street"
            }, null, 32),
            _createVNode("button", {
              disabled: _ctx.identificationLoading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploadFile('file-identification'))),
              class: "btn btn-sat-street"
            }, [
              (_ctx.identificationLoading)
                ? (_openBlock(), _createBlock("span", _hoisted_17, [
                    _hoisted_18
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_19, "Select File"))
            ], 8, ["disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            (!_ctx.identificationBackSuccess)
              ? (_openBlock(), _createBlock("svg", _hoisted_22, [
                  _hoisted_23
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_24, [
                  _hoisted_25
                ]))
          ]),
          _createVNode("div", _hoisted_26, [
            _hoisted_27,
            _hoisted_28,
            (_ctx.identificationBackSuccess)
              ? (_openBlock(), _createBlock("small", _hoisted_29, [
                  _createVNode("a", {
                    class: "link pointer",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadDocument(_ctx.identificationBackKey)))
                  }, " See Uploaded Document. ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("input", {
              onInput: _cache[5] || (_cache[5] = e => _ctx.onOpenFile(e, 'identificationBack')),
              style: {"display":"none"},
              id: "file-identification-back",
              type: "file",
              accept: "image/*, application/pdf",
              class: "btn btn-sat-street"
            }, null, 32),
            _createVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.uploadFile('file-identification-back'))),
              class: "btn btn-sat-street",
              disabled: _ctx.identificationBackLoading
            }, [
              (_ctx.identificationBackLoading)
                ? (_openBlock(), _createBlock("span", _hoisted_31, [
                    _hoisted_32
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_33, "Select File"))
            ], 8, ["disabled"])
          ])
        ]),
        _hoisted_34,
        _hoisted_35,
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            (!_ctx.addressSuccess)
              ? (_openBlock(), _createBlock("svg", _hoisted_38, [
                  _hoisted_39
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_40, [
                  _hoisted_41
                ]))
          ]),
          _createVNode("div", _hoisted_42, [
            _hoisted_43,
            _hoisted_44,
            (_ctx.addressSuccess)
              ? (_openBlock(), _createBlock("small", _hoisted_45, [
                  _createVNode("a", {
                    class: "link pointer",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadDocument(_ctx.addressKey)))
                  }, " See Uploaded Document. ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_46, [
            _createVNode("input", {
              onInput: _cache[8] || (_cache[8] = e => _ctx.onOpenFile(e, 'address')),
              style: {"display":"none"},
              id: "file-address",
              type: "file",
              accept: "image/*, application/pdf",
              class: "btn btn-sat-street"
            }, null, 32),
            _createVNode("button", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.uploadFile('file-address'))),
              class: "btn btn-sat-street",
              disabled: _ctx.addressLoading
            }, [
              (_ctx.addressLoading)
                ? (_openBlock(), _createBlock("span", _hoisted_47, [
                    _hoisted_48
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_49, "Select File"))
            ], 8, ["disabled"])
          ])
        ]),
        (!_ctx.$isAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_50, [
              _createVNode("div", _hoisted_51, [
                _createVNode(_component_router_link, { to: { name: 'verify.one' } }, {
                  default: _withCtx(() => [
                    _hoisted_52
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, { to: { name: 'verify.zero' } }, {
                  default: _withCtx(() => [
                    _createVNode("button", {
                      disabled: !_ctx.allFilesSuccess,
                      type: "button",
                      class: "btn btn-sat-street ml-4"
                    }, [
                      _hoisted_53,
                      _hoisted_54
                    ], 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_55
    ])
  ]))
}